import { SiteListingPaginationProps } from "pages/Site/pages/type";
import React from "react";
import { Pagination } from "shared";

const StoreListingPagination = ({
  onChange,
  totalPage,
}: SiteListingPaginationProps) => {
  if (totalPage == 0) return null;
  return <Pagination totalPage={totalPage} onChange={onChange} />;
};

export default StoreListingPagination;
